import { useEffect, useState } from 'react';
import { LogIn, LogOut } from 'lucide-react';
import { useToastStore } from '../store';
import { api } from '../utils/api';

export function ClockButton() {
  const { addToast } = useToastStore();
  const [isClockedIn, setIsClockedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [clockInTime, setClockInTime] = useState<string | null>(null);

  useEffect(() => {
    loadClockStatus();
  }, []);

  const loadClockStatus = async () => {
    try {
      const result = await api.getClockStatus();
      if (result.success && result.data) {
        setIsClockedIn(result.data.is_clocked_in);
        setClockInTime(result.data.clock_in_time);
      }
    } catch (error) {
      console.error('Failed to load clock status:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClockIn = async () => {
    setIsProcessing(true);
    try {
      const result = await api.clockIn();
      if (result.success && result.data) {
        setIsClockedIn(true);
        setClockInTime(result.data.clock_in_time);
        addToast('Clocked in successfully', 'success');
      } else {
        addToast(result.error || 'Failed to clock in', 'error');
      }
    } catch (error) {
      addToast('Failed to clock in', 'error');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleClockOut = async () => {
    setIsProcessing(true);
    try {
      const result = await api.clockOut();
      if (result.success) {
        setIsClockedIn(false);
        setClockInTime(null);
        addToast('Clocked out successfully', 'success');
      } else {
        addToast(result.error || 'Failed to clock out', 'error');
      }
    } catch (error) {
      addToast('Failed to clock out', 'error');
    } finally {
      setIsProcessing(false);
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      {isClockedIn && clockInTime && (
        <span className="text-xs text-slate-500 hidden sm:inline">
          Clocked in: {new Date(clockInTime).toLocaleTimeString()}
        </span>
      )}
      <button
        onClick={isClockedIn ? handleClockOut : handleClockIn}
        disabled={isProcessing}
        className={`btn btn-sm ${
          isClockedIn ? 'btn-danger' : 'btn-success'
        }`}
        title={isClockedIn ? 'Clock Out' : 'Clock In'}
      >
        {isProcessing ? (
          <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : isClockedIn ? (
          <>
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">Clock Out</span>
          </>
        ) : (
          <>
            <LogIn className="w-4 h-4" />
            <span className="hidden sm:inline">Clock In</span>
          </>
        )}
      </button>
    </div>
  );
}

